import { useMemo } from 'react';
import { useGraphql } from 'utils/hooks/useGraphql';
import { queryVerifiedContactCardById } from '../queries';

export const useGetVerifiedContactCardById = (options: Record<string, any> = {}) => {
  const queryOptions = useMemo(
    () => ({
      notifyOnNetworkStatusChange: true,
      ...options,
    }),
    [options],
  );

  const { data } = useGraphql(queryVerifiedContactCardById, queryOptions);

  const results = data?.getVerifiedContactCardById?.displayName ?? '';

  return {
    results,
  };
};
